import React, {useState, useEffect} from 'react';
import {useGetAccountsQuery} from '../../../data/api';
import SettingsTable from './SettingsTable';
import {accountColumns} from '../../../constants';

const Accounts = () => {
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [fetchedAccounts, setFetchedAccounts] = useState([]);
  const [paginationId, setPaginationId] = useState(0);
  const {data, isSuccess, isFetching, isError} = useGetAccountsQuery({
    paginationId,
    limit: 100,
  });

  useEffect(() => {
    if (isSuccess) {
      setFetchedAccounts(data);
      if (isFirstRender) {
        // only set total rows on first render
        setTotalRows(data[0].total_count);
        setIsFirstRender(false);
      }
    }
  }, [data, isSuccess, paginationId]);
  return (
    <SettingsTable
      isFetching={isFetching}
      isError={isError}
      tableData={fetchedAccounts}
      totalRows={totalRows}
      tableHeaders={accountColumns}
      pageTitle={'Accounts'}
      badgeTitle={'accounts'}
      setPaginationId={setPaginationId}
    />
  );
};

export default Accounts;
